import AdminTestStructureBlock from "../../components/personal/AdminSettingsPage/AdminTestStructure/AdminTestStructureBlock"
import MainNavbar from "../../components/reuse/MainNavbar"
import PersonDropdown from "../../components/reuse/PersonDropdown"
import { TypicalPageStructure } from "../../components/reuse/TypicalPageStructure"

const AdminTestStructure = () => {
    return(
        <>
        <TypicalPageStructure pageLabel={"Структура теста"}>
                <AdminTestStructureBlock/>
        </TypicalPageStructure>
        </>
    )
}

export default AdminTestStructure